module.exports = __webpack_public_path__ + "img/cze.2339f3df.svg";